import { render, staticRenderFns } from "./FaqEntities.vue?vue&type=template&id=25d76aa4&scoped=true&"
import script from "./FaqEntities.vue?vue&type=script&lang=js&"
export * from "./FaqEntities.vue?vue&type=script&lang=js&"
import style0 from "./FaqEntities.vue?vue&type=style&index=0&id=25d76aa4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25d76aa4",
  null
  
)

export default component.exports